import { classes } from '@/uiPrimitives/base/classes.helpers';
import {
	subgridColumnsBase,
	subgridColumnsSprinkles,
	supergridColumnsBase,
	supergridColumnsSprinkles,
} from './subgridColumns.css';
import { RequiredProps } from '@/globals/helpers/typescript.helpers';

/**
 * The parent of the subgrid. Use this to define the columns for the subgrid.
 */
export const supergridColumns = (
	props: RequiredProps<
		Parameters<typeof supergridColumnsSprinkles>[0],
		'gridTemplateColumns'
	>,
) => {
	return classes(supergridColumnsBase, supergridColumnsSprinkles(props));
};

/**
 * To create CSS subgrid columns
 *
 * Use this when children need to align their content to each other
 *
 * Note: normal `pageGrid`’s can be nested. This class is only for when you need CSS subgrid.
 */
export const subgridColumns = (
	props: Parameters<typeof subgridColumnsSprinkles>[0],
) => {
	return classes(subgridColumnsBase, subgridColumnsSprinkles(props));
};
